import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert, Divider } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction, printVariable, removeNonDigits} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';
import { findCode } from '@util/helper';
import useDelegate from "@hooks/useDelegate";
import useAlert from "@hooks/useAlert";
import { RefSelector } from 'ag-grid-community';
const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ManagerStudentPart = ({fields, record, callback, dgRef}) => {
  console.log('ManagerStudentPart rendering...');
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)
  const updateRef = useRef(false)
  const {alert, renderAlert} = useAlert()
  const inputsRef = useRef({})
  const onLoad = async() => {
    const url =`/student/${record.id}`
    const resp = await WebService.get(url, {phone: record.gdnPhone })
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const gdn = JSON.parse(repMessage.gdn)
      const regiAndLectureList = JSON.parse(repMessage.regiAndLectureList)
      factor.gdn = gdn
      factor.regiAndLectureList = regiAndLectureList
      console.log('regiAndLectureList', regiAndLectureList)
      updateState()

    }
    else {
      alert(resp.repMessage)
    }
  }

  useEffect(() => {
    console.log('ManagerStudentPart useEffect', record)
    onLoad()
  },[record])

  const gdnFields = [
    {field:'name', placeholder:'성명'},
    {field:'loginId', placeholder:'ID'},
    {field:'phone', placeholder:'전화번호'},
    {field:'phoneCertYn', placeholder:'휴대폰인증'},
    {field:'emailCertYn', placeholder:'이메일인증'},
  ]

  const regiLectureFields = [
    {field:'year', placeholder:'년도', table:'smst'},
    {field:'gisu', placeholder:'기수', table:'smst'},
    {field:'title', placeholder:'강좌제목', table:'lecture'},
    {field:'statCode', placeholder:'강좌상태', table:'lecture', fn:(code) => findCode(codes, 'SA08', code)},
    {field:'statCode', placeholder:'신청상태', table:'regi', fn:(code) => findCode(codes, 'SA12', code)},

  ]

  const handleClose = () => {
    dgRef.current.close()
    if(callback){
      callback(updateRef.current)
    }
  }

  const onSubmit = async () => {
    const url = '/student'
    const data = {...activeRow, id: factor.id}
    if(data.gdnPhone && data.gdnPhone.length != 11) {
      alert('보호자 전화번호는 11자리이어야 합니다.')
      return
    }

    // if(!data.grade) {
    //   alert('학년이 비어 있습니다.')
    //   return
    // }
    // else {
    //   const grades = [1,2,3,4,5,6]
    //   if(!grades.includes(+data.grade)) {
    //     alert('학년 정보가 올바르지 않습니다.')
    //     return
    //   }
    // }

    const resp = await WebService.post(url, data)
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const student = JSON.parse(repMessage.record)
      factor.id = student.id
      updateRef.current = true
      alert('저장되었습니다.')
    }
    else {
      alert(resp.repMessage)
    }
  }

  const validate = async () => { }
  const {activeRow, errors, updateState, handleChange, handleSubmit, factor} = useDelegate({
    initialValues: { ...record },
    onSubmit: onSubmit,
    validate: validate,
  });

  const [emailError, setEmailError] = useState('');
  const [passwordState, setPasswordState] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [nameError, setNameError] = useState('');
  const [registerError, setRegisterError] = useState('');
  const [schoolList, set_schoolList] = useState([])
  // const Boxs = styled(Box)`
  //   padding-bottom: 40px !important;
  // `;
    

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    
  return (
    <Container component="main" maxWidth="lg">
      <Box
        sx={{
          marginTop: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography component="h1" variant="h5">
          기본정보
        </Typography>
        <Boxs component="form" noValidate sx={{ mt: 3 }}>
          <FormControl component="fieldset" variant="standard" fullWidth>
            <Grid container spacing={2}>
              {
                fields.map((col, index) => {
                  if(col.visible) {
                    if(col.field === 'ftYn') {
                      return(
                        <>
                        <Grid item xs={12} sm={3} key={col.field}>
                          <FormControl fullWidth>
                            <InputLabel required id='ftYn' >
                                {col.placeholder}
                            </InputLabel>
                            <Select
                              labelId='ftYn'
                              required
                              label={col.placeholder}
                              name={col.field}
                              defaultValue={activeRow[col.field]}
                              onChange={handleChange}
                            >
                              {
                                col.selList.map(l => {
                                  return(
                                    <MenuItem key={l} value={l}>{l}</MenuItem>
                                  )
                                })
                              }
                            </Select>
                          </FormControl>

                        </Grid>
                        </>
                      )
                    }
                    else if(col.type === 'auto') {
                      return(
                        <Grid item xs={12} sm={3} key={col.field}>
                          <Autocomplete
                            disablePortal
                            options={schoolList}
                            name={col.field}
                            value={schools.find(r => r.id === +activeRow[col.field])}
                            onInputChange={async (event, value, reason) => {
                              if(reason === 'input') {
                                const records = await searchSchool(value)
                                set_schoolList(records)
                              }
                            }}
                            onChange={(e, v ) => {
                              activeRow[col.field] = v.id
                            }}
                            size='small'
                            getOptionLabel={(option) => option.label}
                            readOnly={true}
                            renderInput={(params) => <TextField  {...params} label="학교명"/>}
                          />
                        </Grid>
                      )
                    }
                    else {
                      return(
                        <Grid item xs={12} sm={3} key={col.field}>
                          <TextField
                            size='small'
                            required
                            fullWidth
                            name={col.field}
                            label={col.placeholder}
                            inputRef={el => inputsRef.current[col.field] = el}
                            defaultValue={activeRow[col.field]}
                            onChange={e => {
                              if(col.field === 'gdnPhone' || col.field ==='grade' || col.field === 'classNum') {
                                const newVal = removeNonDigits(e.target.value)
                                inputsRef.current[col.field].value = newVal
                              }
                              handleChange(e)
                            }}
                            inputProps={
                              col.field == 'gdnPhone' ? {
                                maxLength:11
                              } : {}
                            }
                          />
                        </Grid>
                      )
                    }
                      
                  }
                })
              }
            </Grid>
          </FormControl>
        <FormHelperTexts>{registerError}</FormHelperTexts>
      </Boxs>
      <Divider />
      <Typography component="h1" variant="h5">
        보호자 정보
      </Typography>
      <Box sx={{mt:1, width:'100%'}}>
        <Grid container sx={{bgcolor:'#fafafa'}}>
        {
          gdnFields.map(d => {
            return(
              <Grid item xs={12} sm={2}>{d.placeholder}</Grid>
            )
          })
        }
        </Grid>
        <Grid container>
        {
          gdnFields.map(d => {
            return(
              <Grid item xs={12} sm={2} sx={{fontSize:'0.9em'}} >{activeRow.gdn[d.field]}</Grid>
            )
          })
        }
        </Grid>
      </Box>
      {
        activeRow.remark.trim().length > 0 ? (
          <>
            <Divider sx={{mt:5}} />
              <Typography component="h1" variant="h5" > 
                비고
              </Typography>
              <Typography>
                {activeRow.remark}
              </Typography>

              {/* <Box sx={{mt:1, width:'100%'}}>
                <TextField
                  rows={5}
                  fullWidth
                  multiline
                  label={'비고'}
                  defaultValue={activeRow.remark}
                  onChange={ e => {
                    activeRow.remark = e.target.value
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.stopPropagation(); // prevent form submit
                    }
                  }}
                />
              </Box> */}
          </>
        ) : null
      }
      
        
      <Divider sx={{mt:5}}/>  
      <Typography component="h1" variant="h5" >
        수강(신청) 정보
      </Typography>
      <Box sx={{mt:1, width:'100%'}}>
        <Grid container sx={{bgcolor:'#fafafa'}}>
        {
          regiLectureFields.map(d => {
            return (
              <Grid item xs={12 / regiLectureFields.length}>
              {d.placeholder}
              </Grid>
            )
          })
        }
        </Grid>
        <Grid container>
        {
          activeRow.regiAndLectureList.map(row => {
            return(
              regiLectureFields.map(col => {
                if(col.fn && row[col.table][col.field]) {
                  const code = col.fn(row[col.table][col.field])

                  return(
                    <Grid item xs={12 / regiLectureFields.length} sx={{fontSize:'0.9em'}}>
                      {code ? code.name: ''}
                    </Grid>
                  )
                }
                else {
                  return(
                    <Grid item xs={12 / regiLectureFields.length} sx={{fontSize:'0.9em'}}>
                      {row[col.table][col.field]}
                    </Grid>
                  )
                }
                  
              })
            )
          })
        }
        </Grid>
      </Box>
    </Box>
    <div style={{ display: "flex", justifyContent:'center', alignItems:'center' }}>
      <Button variant='outlined' color='primary' size='small' onClick={handleClose} sx={{ mt: 5, mr:1 }} >
        닫기
      </Button>
      <Button variant='contained' color='primary' size='small' onClick={handleSubmit} sx={{ mt: 5 }}>
        저장
      </Button>
    </div>
    {renderSnackbar()}
    {renderIndicator()}
    {renderAlert()}
  </Container>
  );
  
}

export default ManagerStudentPart
